/* product-tech-data.js  (South Mini Splits)  v2-lite
   --------------------------------------------------
   Lightweight, lazy-loaded Technical Data renderer.
   - No global MutationObserver (perf!)
   - Lazy loads tecinfo.json ONLY when #sms-techdata-target first becomes visible
     (or immediately if already visible when script runs)
   - Renders directly *into* the visible target
   - Event delegation for SKU switching (never lose listeners)
   - Title-case keys; safe HTML; linkify; skip empty cert/accessory objects
*/

(function(){
  var SOURCE_SEL = '#sms-techdata-source .tech-data-root, #sms-techdata-source.tech-data-root';
  var TARGET_SEL = '#sms-techdata-target';
  var hasLoaded  = false;   // loaded & rendered at least once
  var loading    = false;   // currently fetching
  // >>> PATCH BEGIN: Special TechData Group Config -------------------
  // Canonicalize SKUs for comparison:
  //   - uppercase
  //   - drop anything after first "(" (common length annotation)
  //   - strip spaces
function isMrCoolProduct() {
  var title =
    (document.querySelector(SOURCE_SEL)?.getAttribute('data-techdata-prod-title')) ||
    document.title || '';
  return /\bMR\s*COOL\b/i.test(title);
}

// Given a base SKU, return possible MRCOOL component SKUs
function deriveMrCoolComponents(baseSku) {
  var up = String(baseSku || '').toUpperCase();
  var parts = up.split('-');
  var hpIdx = parts.indexOf('HP');
  if (hpIdx === -1) return [];                 // nothing to do
  var head = parts.slice(0, hpIdx + 1);        // through “HP”
  var tail = parts.slice(hpIdx + 1);           // everything after

  function build(insert) { return [...head, insert, ...tail].join('-'); }
  return [build('C'), build('WMAH'), build('MUAH')];
}
function canonSku(s){
  if (!s) return '';
  return String(s)
           .toUpperCase()
           .split('(')[0]               // drop anything after a “(”
           .replace(/[-_ ]?\d+FT$/i, '') // strip trailing “‑16FT”, “25FT”, “50FT”
           .replace(/[^A-Z0-9]/g, '')    // keep only letters & digits
           .trim();
}


  function makeGroup(id, members){
    return {id:id, label:id.toUpperCase(), members:members.map(canonSku)};
  }

  // ----- Group Membership Lists --------------------------------------
var SPECIAL_GROUPS = [
  makeGroup('Installation Kit for mini splits (Line Sets) ACiQ 1/4-3/8',  ["201813","216740","366396"]),
  makeGroup('Installation Kit for mini splits (Line Sets) ACiQ 1/4-1/2',  ["201814","216741","366402"]),
  makeGroup('Installation Kit for mini splits (Line Sets) ACiQ 1/4-5/8',  ["218863","219066","366408"]),
  makeGroup(
    'Installation Kit (Line Sets) ACiQ 3/8-5/8',
    [
      "221885","216748","366428",      // numeric “PA‑PLY” style
      "LS38583830","LS38583850"        // ← add these two LS variants
    ]
  ),
  makeGroup('Installation Kit (Line Sets) ACiQ 3/8-1 1/8',  ["LS381183850"]),
  makeGroup('Installation Kit (Line Sets) ACiQ 3/8-3/4',  ["LS38343830","LS38343850"]),
  makeGroup('Installation Kit (Line Sets) ACiQ 3/8-7/8',  ["LS38783830","LS38783850"]),
  makeGroup('Installation Kit (Line Sets) N1 1/4-3/8',    ["PJX-N1-C16FTW-MAX(16FT)","PJX-N1-C25FTW-MAX(25FT)","PJX-N1-C50FTW-MAX(50FT)"]),
  makeGroup('Installation Kit (Line Sets) N2 1/4-1/2',    ["PJX-N2-C16FTW-MAX(16FT)","PJX-N2-C25FTW-MAX(25FT)","PJX-N2-C50FTW-MAX(50FT)"]),
  makeGroup('Installation Kit (Line Sets) N3 3/8-5/8',    ["PJX-N3-C16FTW-MAX(16FT)","PJX-N3-C25FTW-MAX(25FT)","PJX-N3-C50FTW-MAX(50FT)"]),
  makeGroup('Installation Kit (Line Sets) N4 3/8-3/4',    ["PJX-N4-C25FTW-MAX (25FT)","PJX-N4-C50FTW-MAX (50FT)"]),
  makeGroup('Installation Kit (Line Sets) N6 3/8-7/8',    ["PJX-N6-C25FTW-MAX (25FT)","PJX-N6-C50FTW-MAX (50FT)"]),
  makeGroup('Installation Kit (Line Sets) AB7 1/4-5/8',   ["AB7-25FT"]),
  makeGroup('Installation Kit (Line Sets) MRCOOL 1/4-1/2',["DIY16-1412-O","DIY25-1412-O","DIY25-1412C-O","DIY35-1412C-O","DIY50-1412C-O"]),
  makeGroup('Installation Kit (Line Sets) MRCOOL 1/4-3/8',["DIY16-1438-O","DIY25-1438-O","DIY35-1438C-O","DIY50-1438C-O"]),
  makeGroup('Installation Kit (Line Sets) MRCOOL 3/8-5/8',["DIY16-3858-O","DIY25-3858-O","DIY25-3858C-O","DIY35-3858C-O","DIY50-3858C-O"]),
  makeGroup('Installation Kit (Line Sets) MRCOOL 3/8-3/4',["NV15-3834-O","NV25-3834-O","NV35-3834-O","NV50-3834-O"]),
  makeGroup('Heat Kit (Aux/Elect Heat) ACiQ',             ["PEAH-05C(UL)","PEAH-08C(UL)","PEAH-10C(UL)","PEAH-15C(UL)","PEAH-20C(UL)"]),
  makeGroup('Heat Kit (Aux/Elect Heat) MRCOOL',           ["MVPHK05","MVPHK08","MVPHK10","MVPHK15","MVPHK20"]),
  makeGroup('Heat Kit (Aux/Elect Heat) C&H R410A',        ["CH-EH05KW","CH-EH10KW","CH-EH15KW","CH-EH20KW"]),
  makeGroup('Heat Kit (Aux/Elect Heat) C&H R454B',        ["CH-NREH05KW","CH-NREH10KW","CH-NREH15KW","CH-NREH20KW"])
];

  // <<< PATCH END: Special TechData Group Config ---------------------
  // Kick off once DOM is ready
  onReady(function(){
    var target = document.querySelector(TARGET_SEL);
    if (!target) return;

    // Observe visibility (lazy load)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            io.disconnect();
            ensureLoaded();
          }
        });
      }, {rootMargin:'0px', threshold:0.1});
      io.observe(target);
    } else {
      // Fallback: just load immediately
      ensureLoaded();
    }

    // If theme triggers tab switching via events, listen so we can load
    document.addEventListener('sms:techdata:open', ensureLoaded, {once:true});

    // Delegate SKU tab clicks (works across re-renders)
    target.addEventListener('click', function(evt){
      var btn = evt.target.closest('.sms-sku-tab');
      if (!btn) return;
      var idx = parseInt(btn.getAttribute('data-idx'),10);
      switchSku(target, idx);
    });
  });

  /* Ensure data loaded (guarded) ------------------------------------ */
  function ensureLoaded(){
    if (hasLoaded || loading) return;
    loading = true;

    var src = document.querySelector(SOURCE_SEL);
    var tgt = document.querySelector(TARGET_SEL);
    if (!tgt) return;

    if (!src) {
      tgt.innerHTML = '<p>Technical data not configured.</p>';
      loading=false; hasLoaded=true;
      return;
    }

    var jsonUrl    = src.getAttribute('data-techdata-json') || '';
    var prodSku    = src.getAttribute('data-techdata-prod-sku') || '';
    var rawVarSkus = src.getAttribute('data-techdata-variant-skus') || '[]';

    if (!jsonUrl) {
      tgt.innerHTML = '<p>Technical data not configured.</p>';
      loading=false; hasLoaded=true;
      return;
    }

    tgt.innerHTML = '<p>Loading technical data…</p>';

    var variantSkus = safeParseJson(rawVarSkus);
    var skuList     = normalizeAndDedupeSkus(prodSku, variantSkus);

    fetch(jsonUrl, {cache:'force-cache'})
      .then(function(r){
        if(!r.ok) throw new Error('tecinfo.json '+r.status);
        return r.json();
      })
      .then(function(db){
        hasLoaded=true; loading=false;
        renderTechData(tgt, skuList, db);
      })
      .catch(function(err){
        console.error('[TechData] load error', err);
        tgt.innerHTML = '<p>Technical data temporarily unavailable.</p>';
        hasLoaded=true; loading=false;
      });
  }

  /* Switch visible SKU block --------------------------------------- */
 function switchSku(container, idx){
   var tabs   = container.querySelectorAll('.sms-sku-tab');
   // top-level sections have the class sms-sku-family-block
   var blocks = container.querySelectorAll('.sms-sku-family-block');
   tabs.forEach(function(b,i){ b.classList.toggle('active', i===idx); });
   blocks.forEach(function(s,i){ s.style.display = (i===idx?'block':'none'); });
 }


 function getSkuFamily(sku){
   // Extracts family root like PJX-N1 from a full SKU (fallback: full)
   var m = String(sku||'').toUpperCase().match(/^([A-Z0-9]+-[A-Z0-9]+)/);
   return m ? m[1] : String(sku||'').toUpperCase();
}

  /* Render main UI -------------------------------------------------- */
/* ===============================================================
   FULL WORKING renderTechData – no duplicate const/var, includes
   fuzzy MRCOOL matching *and* original special‑group / line‑set logic
   =============================================================== */

// ------------------------------------------------------------------
// Helper: fuzzy MRCOOL lookup (numeric‑insensitive)
// ------------------------------------------------------------------
function mrCoolFuzzyFind(headInsert, tailWanted, map){
  const prefix  = headInsert + '-';
  const wantKey = tailWanted.replace(/[0-9]/g,'');
  for(const upSku in map){
    if(!upSku.startsWith(prefix)) continue;
    const candKey = upSku.slice(prefix.length).replace(/[0-9]/g,'');
    if(candKey === wantKey) return map[upSku];
  }
  return null;
}

/* ------------------------------------------------------------------
   Main renderer
   ------------------------------------------------------------------*/
function renderTechData(target, wantedSkus, db){
  /* 0. Build lookup maps ----------------------------------------- */
  const map      = Object.create(null);  // UPPERCASE SKU → rec
  const canonMap = Object.create(null);  // CANON SKU    → rec
  db.forEach(rec=>{
    if(!rec || !rec.sku) return;
    const up = rec.sku.toUpperCase();
    map[up] = rec;
    const c = canonSku(rec.sku);
    if(!canonMap[c]) canonMap[c] = rec;
  });

  /* 1. Build master wanted list (base + companions) -------------- */
  const allWanted = [];
  (wantedSkus||[]).forEach(raw=>{
    if(!raw) return;
    allWanted.push(raw);
    deriveMrCoolComponents(raw).forEach(comp=> allWanted.push(comp));
  });
  const seenWanted = Object.create(null);
  const wantedDedup = allWanted.filter(s=>{
    const up = s.toUpperCase();
    if(seenWanted[up]) return false;
    seenWanted[up] = 1;
    return true;
  });

  /* 2. Resolve wanted SKUs → tech‑data records (with fuzzy) ------ */
  const initialRecs = [];
  const seenCanon   = Object.create(null);

  wantedDedup.forEach(raw=>{
    let rec = map[raw.toUpperCase()];                     // exact

    if(!rec){                                             // fuzzy numeric‑agnostic
      const up    = raw.toUpperCase();
      const parts = up.split('-');
      const hpIdx = parts.indexOf('HP');
      if(hpIdx>-1 && hpIdx<parts.length-1){
        const headInsert = parts.slice(0,hpIdx+2).join('-');
        const tailWanted = parts.slice(hpIdx+2).join('-');
        rec = mrCoolFuzzyFind(headInsert, tailWanted, map);
      }
    }

    if(!rec) return;
    initialRecs.push(rec);
    seenCanon[canonSku(rec.sku)] = 1;
  });

  /* 3. One‑SKU‑per‑group base list ------------------------------- */
  const groupList = [];
  const seenBase  = Object.create(null);
  initialRecs.forEach(rec=>{
    if(seenBase[rec.sku]) return;
    seenBase[rec.sku] = 1;
    groupList.push({family:rec.sku, items:[rec], forceLabel:false});
  });

  /* 4. Accessory scan ------------------------------------------- */
  const accCandSet = Object.create(null);   // canon → 1
  const accLinkMap = Object.create(null);   // canon/raw → url

  initialRecs.forEach(rec=>{
    if(!Array.isArray(rec.accessories)) return;
    rec.accessories.forEach(a=>{
      const guess = acc_guessSkuFromAccItem(a);       // e.g., "221885"
      const raw   = String(guess||'').toUpperCase();  // RAW key
      const c     = canonSku(guess);                  // CANON key

      if (c) accCandSet[c] = 1;

      const u = (a && typeof a==='object' && a.url) ? a.url : '';
      if (!u) return;

      if (c && !accLinkMap[c])   accLinkMap[c]   = u;
      if (raw && !accLinkMap[raw]) accLinkMap[raw] = u;
    });
  });
  // DEBUG (inside renderTechData): check we captured SMS links
  console.debug('[TechData] accLinkMap snapshot', {
    '221885': accLinkMap['221885'],
    '216748': accLinkMap['216748'],
    '366428': accLinkMap['366428']
  });
  /* 5. Special-group (line sets, heat kits…) logic --------------- */
  const specialShown = Object.create(null);

  SPECIAL_GROUPS.forEach(cfg=>{
    const shouldShow = cfg.members.some(m=> seenCanon[m] || accCandSet[m]);
    if(!shouldShow) return;

    const items = [];
    cfg.members.forEach(memCanon=>{
      const rec = canonMap[memCanon];
      if(!rec) return;

      const clone = Object.assign({}, rec);

      // Try link via canonical key first, then via raw record SKU
      const rawKey = String(rec.sku||'').toUpperCase();
      const linkFromParent =
        accLinkMap[memCanon] || (rawKey && accLinkMap[rawKey]) || null;

      if (linkFromParent) {
        clone._linkUrl = linkFromParent;                           // top priority
        clone.url      = linkFromParent;                           // harden fallback
        clone.handle   = acc_getHandleFromUrl(linkFromParent);     // local handle
      }

      clone._isAccessory = true;
      items.push(clone);
      specialShown[canonSku(clone.sku)] = 1;

      // DEBUG: confirm what each special item will link to
      console.debug('[TechData] special item link',
        clone.sku, { _linkUrl: clone._linkUrl, url: clone.url, handle: clone.handle });
    });

    if(items.length){
      groupList.push({family:cfg.label, items, forceLabel:true});
    }
  });

  /* 6. Drop base groups fully covered by a special --------------- */
  const filtered = groupList.filter(g=>{
    if(g.forceLabel) return true;
    const allCovered = g.items.every(it=> specialShown[canonSku(it.sku)]);
    return !allCovered;
  });
  groupList.length = 0; groupList.push(...filtered);

  /* 7. Bail out if none ----------------------------------------- */
  if(!groupList.length){
    target.innerHTML = '<p>No technical data found for this configuration.</p>';
    return;
  }

  /* 8. Tabs ------------------------------------------------------ */
  let html = '<div class="sms-sku-tabs">';
  groupList.forEach((g,i)=>{
    const label = g.forceLabel ? g.family : (g.items.length>1?g.family:g.items[0].sku);
    html += `<button type="button" class="sms-sku-tab${i===0?' active':''}" data-idx="${i}">${esc(label)}</button>`;
  });
  html += '</div>';

  /* 9. Content blocks ------------------------------------------- */
  groupList.forEach((g,i)=>{
    html += `<section class="sms-sku-family-block"${i===0?'':' style="display:none"'}>`;
    g.items.forEach(item=>{ html += buildSkuBlock(item,true); });
    html += '</section>';
  });

  target.innerHTML = html;
}


 // Helper: try to extract a SKU-ish identifier from an accessory item
 function acc_guessSkuFromAccItem(a){
   if (!a) return '';
   if (typeof a === 'string') return a;
   if (typeof a === 'object'){
     // Try explicit sku-like fields; fall back to any label-ish field
     return a.sku || a.SKU || a.part || a.part_number || a.partnumber ||
            a.label || a.title || a.name || '';
   }
   return '';
 }


  /* ===================================================================
   ACCESSORY CAROUSEL SUPPORT
   -------------------------------------------------------------------
   Accepts mixed array:
     [
       "string accessory",
       {label,url,product_id,alt_products:[{product_id,url},...]},
       ...
     ]
   Expands -> unique product objects by product_id (primary + alts).
   Each product rendered as a lazy-hydrated card:
     • Image
     • Title (from live product JSON)
     • Variant selector (if >1)
     • Price (updates w/ variant)
     • Add to Cart / Sold Out
   =================================================================== */

/* --- Parse product handle from a Shopify product URL --------------- */
function acc_getHandleFromUrl(u){
  if (!u) return '';
  try {
    var url = new URL(u, window.location.origin);
    // /products/<handle>(/...)  -> we want <handle>
    var segs = url.pathname.split('/').filter(Boolean);
    var ix = segs.indexOf('products');
    if (ix > -1 && segs[ix+1]) return segs[ix+1];
    // fallback: assume last seg
    return segs.pop() || '';
  } catch(e){
    return '';
  }
}

/* --- Normalize incoming accessory array -> {product_id,handle,url,label} --- */
function acc_normalizeList(arr){
  if (!Array.isArray(arr) || !arr.length) return [];
  var out = [];
  var seen = Object.create(null);

  function pushOne(lbl, url, pid){
    pid = pid ? String(pid).trim() : '';
    // Dedupe priority: product_id first; fallback to handle; fallback to url
    var key = pid || acc_getHandleFromUrl(url) || url;
    if (!key || seen[key]) return;
    seen[key] = 1;
    out.push({
      label: lbl || '',
      url: url || '',
      product_id: pid,
      handle: acc_getHandleFromUrl(url)
    });
  }

  arr.forEach(function(item){
    if (!item) return;

    if (typeof item === 'string'){
      // plain string — just render as link fallback
      pushOne(item, detectUrl(item), '');
      return;
    }

    if (typeof item === 'object'){
      var lbl = item.label || item.title || item.name || '';
      var url = item.url || item.link || item.href || item.product_url || '';
      var pid = item.product_id || item.id || '';
      pushOne(lbl, url, pid);

      // alt_products list?
      if (Array.isArray(item.alt_products)){
        item.alt_products.forEach(function(ap){
          if (!ap) return;
          pushOne(lbl, ap.url || '', ap.product_id || '');
        });
      }
    }
  });

  return out;
}

/* --- Cache: product data by handle --------------------------------- */
var acc_productCache = Object.create(null);   // handle -> Promise(productJSON)
var acc_variantAvailabilityCache = Object.create(null); // variantId -> bool avail

function acc_fetchProduct(handle){
  if (!handle) return Promise.resolve(null);
  if (acc_productCache[handle]) return acc_productCache[handle];
  // Shopify product JSON endpoint
  // Example: /products/handle.js  (returns {id,title,variants[],images[]...})
  acc_productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'})
    .then(function(r){ if(!r.ok) throw new Error(handle+' '+r.status); return r.json(); })
    .catch(function(err){ console.error('[TechData] acc_fetchProduct error', handle, err); return null; });
  return acc_productCache[handle];
}

/* --- Money formatting (basic fallback) ------------------------------ */
function acc_formatMoney(cents){
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney){
    try { return Shopify.formatMoney(cents, Shopify.money_format || "${{amount}}"); } catch(e){}
  }
  return '$' + (cents/100).toFixed(2);
}

/* --- Build carousel wrapper HTML (skeleton; cards hydrate later) --- */
function buildAccessoryCarousel(arr){
  var prods = acc_normalizeList(arr);
  if (!prods.length) return '';

  var h = '<h4>Accessories</h4>';
  h += '<div class="sms-acc-carousel" role="list">';

  prods.forEach(function(p, i){
    var lbl = esc(p.label || '');
    // skeleton card; content filled async
    h += '<article class="sms-acc-card" role="listitem"'
       + ' data-acc-idx="'+i+'"'
       + (p.handle?(' data-handle="'+esc(p.handle)+'"'):'')
       + (p.product_id?(' data-product-id="'+esc(p.product_id)+'"'):'')
       + (p.url?(' data-url="'+esc(p.url)+'"'):'')
       + '>'
       +   '<div class="sms-acc-card-inner">'
       +     '<div class="sms-acc-card-media sms-acc-loading"></div>'
       +     '<div class="sms-acc-card-body">'
       +       '<h5 class="sms-acc-card-title">'+lbl+'</h5>'
       +       '<div class="sms-acc-card-price"></div>'
       +       '<div class="sms-acc-card-variant"></div>'
       +       '<button type="button" class="sms-acc-add-btn" disabled>Loading…</button>'
       +     '</div>'
       +   '</div>'
       + '</article>';
  });

  h += '</div>';
  // schedule hydration after we inject to DOM
  setTimeout(acc_hydrateVisibleAccessoryCards, 0);
  return h;
}

/* --- Hydrate all cards currently in DOM ---------------------------- */
function acc_hydrateVisibleAccessoryCards(){
  document.querySelectorAll('.sms-acc-card').forEach(function(card){
    if (card.getAttribute('data-acc-hydrated') === '1') return;
    var handle = card.getAttribute('data-handle');
    var url    = card.getAttribute('data-url');
    acc_fetchProduct(handle).then(function(prod){
      acc_hydrateAccessoryCard(card, prod, url);
    });
  });
}

/* --- Populate one card w/ product data ----------------------------- */
function acc_hydrateAccessoryCard(card, prod, fallbackUrl){
  card.setAttribute('data-acc-hydrated','1');
  var mediaEl   = card.querySelector('.sms-acc-card-media');
  var titleEl   = card.querySelector('.sms-acc-card-title');
  var priceEl   = card.querySelector('.sms-acc-card-price');
  var variantEl = card.querySelector('.sms-acc-card-variant');
  var btnEl     = card.querySelector('.sms-acc-add-btn');

  if (!prod){
    // fallback: simple link out
    mediaEl.innerHTML = '';
    titleEl.innerHTML = '<a href="'+fallbackUrl+'" target="_blank" rel="noopener">'+titleEl.textContent+'</a>';
    priceEl.textContent = '';
    btnEl.textContent = 'View';
    btnEl.disabled = false;
    btnEl.addEventListener('click', function(){ window.open(fallbackUrl, '_blank'); });
    return;
  }

  // Title — use product.title
  titleEl.innerHTML = '<a href="'+prod.url+'" target="_blank" rel="noopener">'+esc(prod.title)+'</a>';

  // Image
  var imgSrc = (prod.images && prod.images[0]) ? prod.images[0] : '';
  mediaEl.classList.remove('sms-acc-loading');
  mediaEl.innerHTML = imgSrc
    ? '<img loading="lazy" src="'+imgSrc+'" alt="'+esc(prod.title)+'">'
    : '';

  // Variants
  var variants = Array.isArray(prod.variants)?prod.variants:[];
  if (variants.length <= 1){
    variantEl.innerHTML = '';
  } else {
    var sel = '<label><span class="visually-hidden">Select</span><select class="sms-acc-var-sel">';
    variants.forEach(function(v){
      sel += '<option value="'+v.id+'" '+(v.available?'':'disabled')+'>'
           + esc(v.title) + (v.available?'':' (Sold Out)') + '</option>';
    });
    sel += '</select></label>';
    variantEl.innerHTML = sel;
  }

  // Initial price (use first *available* variant, else first)
  var initVar = variants.find(function(v){return v.available;}) || variants[0] || null;
  if (initVar){
    priceEl.textContent = acc_formatMoney(initVar.price);
    btnEl.disabled = !initVar.available;
    btnEl.textContent = initVar.available ? 'Add to Cart' : 'Sold Out';
    btnEl.setAttribute('data-variant-id', initVar.id);
  } else {
    priceEl.textContent = '';
    btnEl.disabled = true;
    btnEl.textContent = 'Sold Out';
  }

  // When variant changes
  if (variantEl.querySelector('select')){
    variantEl.querySelector('select').addEventListener('change', function(e){
      var vid = e.target.value;
      var v   = variants.find(function(x){return String(x.id)===String(vid);});
      if (!v) return;
      priceEl.textContent = acc_formatMoney(v.price);
      btnEl.disabled = !v.available;
      btnEl.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      btnEl.setAttribute('data-variant-id', v.id);
    });
  }

  // Add to Cart
  btnEl.addEventListener('click', function(){
    var vid = btnEl.getAttribute('data-variant-id');
    if (!vid || btnEl.disabled) return;
    btnEl.disabled = true;
    btnEl.textContent = 'Adding…';
    acc_addToCart(vid, 1).then(function(respOk){
      btnEl.disabled = false;
      btnEl.textContent = respOk ? 'Added!' : 'Error';
      if (respOk){
        // fire global event so themes can update mini-cart
        var ev = new CustomEvent('sms:acc:added', {detail:{variant_id:vid}});
        document.dispatchEvent(ev);
      }
    });
  });
}

/* --- AJAX cart add ------------------------------------------------- */
function acc_addToCart(variantId, qty){
  var fd = new FormData();
  fd.append('id', variantId);
  fd.append('quantity', qty||1);
  return fetch('/cart/add.js', {
    method: 'POST',
    body: fd,
    credentials: 'same-origin'
  })
  .then(function(r){ return r.ok; })
  .catch(function(){ return false; });
}
  
function sms_buildProductUrl(rec){
  if (rec._linkUrl) return rec._linkUrl; // highest priority (JSON accessories[])

  var offDomain = rec.url && (function(u){
    try { return (new URL(u)).hostname !== location.hostname; }
    catch(e){ return true; }
  })(rec.url);

  if (rec._isAccessory && rec.handle && (offDomain || !rec.url)) {
    return '/products/' + encodeURIComponent(rec.handle);
  }

  if (rec.url)    return rec.url; 
  if (rec.handle) return '/products/' + encodeURIComponent(rec.handle);
  return '/search?type=product&q=' + encodeURIComponent(rec.sku);
}


/* ---------- tiny helpers just for thumbnails & pdf grid ---------- */
function youtubeId(u=''){
  if (u.includes('youtube.com'))  return u.split('v=')[1]?.split('&')[0]||'';
  if (u.includes('youtu.be/'))    return u.split('youtu.be/')[1]?.split('?')[0]||'';
  return '';
}
function pdfLabel(u=''){ return decodeURIComponent(u.split('/').pop()); }

  /* ------------------- Block Builders ------------------------------ */
/* ------------------------------------------------------------------
   Build one SKU block.

   • Accessory records (item._isAccessory === true):
       – SKU heading is a clickable <a> pointing to sms_buildProductUrl(item)
   • Core product records:
       – Heading stays plain text.
------------------------------------------------------------------*/
function buildSkuBlock(item, show){
  var style = show ? '' : ' style="display:none"';

  /* --------- heading HTML ---------------------------------------- */
  var headingHtml = item._isAccessory
      ? '<a href="' + sms_buildProductUrl(item) +
        '" target="_blank" rel="noopener">' + esc(item.sku) + '</a>'
      : esc(item.sku);

  /* --------- start of block -------------------------------------- */
  var h = '<section class="sms-sku-block"' + style + '>';

  if (isObj(item.specs)) {
    h += '<table class="sms-specs">'
       +   '<tr><th colspan="2" class="sku-heading-large">' + headingHtml + '</th></tr>';
    for (var key in item.specs){
      if (!Object.prototype.hasOwnProperty.call(item.specs, key)) continue;
      h += '<tr><th>' + esc(formatKey(key)) + '</th><td>' +
              renderSpecValue(item.specs[key]) +
           '</td></tr>';
    }
    h += '</table>';
  } else {
    h += '<h3 class="sku-heading-large">' + headingHtml + '</h3>';
  }

  /* --------- remaining sections (unchanged) ---------------------- */
  /* ---------- PDFs ------------------------------------------------- */
  h += buildDocGroup('Submittals', item.submittal_pdfs);
  h += buildDocGroup('Manuals',    item.manual_pdfs);
  h += buildDocGroup('Other Docs', item.other_pdfs);
  
  /* ---------- Accessories (carousel) ------------------------------- */
  if (Array.isArray(item.accessories) && item.accessories.length){
    h += buildAccessoryCarousel(item.accessories);
  }
  
  /* ---------- Videos (thumbnail cards) ----------------------------- */
  if (Array.isArray(item.videos) && item.videos.length){
    item.videos.forEach(group=>{
      if (!group || !Array.isArray(group.videos) || !group.videos.length) return;
  
      const cards = group.videos.map(v=>{
        if (!v || !v.url) return '';
        const id    = youtubeId(v.url);
        const thumb = id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : '';
        return `
          <a class="sms-vid-card" href="${v.url}" target="_blank" rel="noopener">
            ${thumb ? `<img src="${thumb}" alt="${esc(v.title||'Video')}" loading="lazy">` : ''}
            <span>${esc(v.title || pdfLabel(v.url))}</span>
          </a>`;
      }).join('');
  
      h += `
        <h4>${esc(group.group_title || 'Videos')}</h4>
        <div class="sms-vid-grid">${cards}</div>`;
    });
  }
  
  /* ---------- Certifications (unchanged) --------------------------- */
  h += renderCertsOrAcc('Certifications', item.certifications);
  
  h += '</section>';
  return h;

}


  function pdfMarkup(arr = []) {
    return arr.map(item => {
      if (!item) return '';

      // Allow plain strings AND {url,label}-style objects
      const href  = (typeof item === 'string') ? item : item.url;
      if (!href) return '';

      const label = (typeof item === 'string')
        ? href.split('/').pop()
        : (item.label || item.title || item.name || href.split('/').pop());

      return `<li class="sms-pdf-item">
                <a href="${href}" target="_blank" rel="noopener">${esc(label)}</a>
              </li>`;
    }).join('');
  }

  /* ---------- patch buildDocGroup ------------------------------- */
  /* ---------- pretty PDF block (grid + icon bullets) --------------- */
  function buildDocGroup(label, arr){
    if (!Array.isArray(arr) || !arr.length) return '';
  
    // one <li> per document
    const items = arr.map(p=>{
      const href  = typeof p === 'string' ? p       : p.url;
      const lbl   = typeof p === 'string'
                      ? pdfLabel(href)
                      : (p.label || p.title || pdfLabel(href));
  
      return `<li class="sms-pdf-item">
                <a href="${href}" target="_blank" rel="noopener">${esc(lbl)}</a>
              </li>`;
    }).join('');
  
    return `
      <h4>${esc(label)}</h4>
      <ul class="sms-pdf-grid">
        ${items}
      </ul>`;
  }



  function renderCertsOrAcc(title, arr){
    if (!Array.isArray(arr) || !arr.length) return '';
    var out = [];
    for (var i=0;i<arr.length;i++){
      var p = parseCertOrAcc(arr[i]);
      if (p) out.push(p);
    }
    if (!out.length) return '';
    var h = '<h4>'+title+'</h4><ul class="sms-doc-list">';
    out.forEach(function(it){
      h += it.url
        ? '<li><a href="'+it.url+'" target="_blank" rel="noopener">'+esc(it.label)+'</a></li>'
        : '<li>'+esc(it.label)+'</li>';
    });
    h += '</ul>';
    return h;
  }

  /* ------------------- Utils -------------------------------------- */
  function onReady(fn){
    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', fn, {once:true});
    } else {
      fn();
    }
  }

  function safeParseJson(raw){
    try { return JSON.parse(raw); }
    catch(e1){
      try {
        var unescaped = raw.replace(/&quot;/g,'"')
                           .replace(/&#34;/g,'"')
                           .replace(/&amp;/g,'&');
        return JSON.parse(unescaped);
      } catch(e2){
        console.warn('[TechData] Bad variant SKU JSON', e2, raw);
        return [];
      }
    }
  }

  function normalizeAndDedupeSkus(prodSku, variantSkus){
    var set = Object.create(null);
    function add(s){ if(!s) return; set[s]=1; }
    add(prodSku);
    (variantSkus||[]).forEach(add);
    var raw = Object.keys(set);
    var cleaned=[];
    raw.forEach(function(sk){
      sk.split('+').forEach(function(part){
        var c = normalizeSkuPart(part);
        if(c) cleaned.push(c);
      });
    });
    var out=[], seen=Object.create(null);
    cleaned.forEach(function(sk){
      var up = sk.toUpperCase();
      if(!seen[up]){seen[up]=1;out.push(sk);}
    });
    return out;
  }

  function normalizeSkuPart(s){
    if(!s) return '';
    s = s.trim();
    s = s.replace(/^(\d+)\s*[xX]\s*[-_]?/, '');
    s = s.replace(/^[xX]\s*(\d+)\s*[-_]?/, '');
    s = s.replace(/[-_]?[xX]\s*\d+$/, '');
    s = s.replace(/\d+\s*[xX]$/, '');
    return s.trim();
  }

  function esc(str){
    return (''+str)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;');
  }

  function detectUrl(str){
    if(!str) return '';
    str = String(str).trim();
    if(/^https?:\/\//i.test(str)) return str;
    if(/^www\./i.test(str)) return 'https://' + str;
    return '';
  }

  function cleanLabelFromUrl(u){
    try {
      if(!/^https?:\/\//i.test(u)) u='https://'+u;
      var url = new URL(u);
      var segs = url.pathname.split('/');
      var last = segs.pop() || segs.pop() || '';
      return last ? decodeURIComponent(last) : url.hostname;
    } catch(e){ return u; }
  }

  function renderSpecValue(v){
    if (v == null) return '';
    if (typeof v !== 'string') return esc(String(v));
    var s = v.trim();
    // contains HTML tags?
    if (/[<][a-zA-Z]/.test(s)) return sanitizeHtml(s);
    // contains URLs?
    if (s.indexOf('http')>-1 || s.indexOf('www.')>-1){
      return s.split(/[\s,;]+/).filter(Boolean).map(function(part){
        var url = detectUrl(part);
        return url
          ? '<a href="'+url+'" target="_blank" rel="noopener">'+esc(cleanLabelFromUrl(url))+'</a>'
          : esc(part);
      }).join('<br>');
    }
    return esc(s);
  }

  function sanitizeHtml(str){
    var tmp = document.createElement('div');
    tmp.innerHTML = str;
    tmp.querySelectorAll('script,style,iframe,object,embed,link,meta').forEach(function(el){el.remove();});
    tmp.querySelectorAll('*').forEach(function(el){
      [].slice.call(el.attributes).forEach(function(attr){
        var n = attr.name.toLowerCase(), v = attr.value;
        if (n.slice(0,2)==='on') el.removeAttribute(attr.name);
        if ((n==='href'||n==='src') && /^\s*javascript:/i.test(v)) el.removeAttribute(attr.name);
      });
    });
    return tmp.innerHTML;
  }

  var PRESERVE_KEYS = {
    'BTU':1,'BTUS':1,'EER':1,'EER2':1,'SEER':1,'SEER2':1,
    'HSPF':1,'HSPF2':1,'COP':1,'CFM':1,'AHRI':1,'DB':1,'DBA':1
  };
  function formatKey(k){
    if(!k) return '';
    var pure = k.replace(/[^\w]/g,'');
    var up = pure.toUpperCase();
    if (PRESERVE_KEYS[up]) return up;
    if (pure.length<=5 && pure===up) return k;
    return k.split(/(\s+|-|\/|_)/).map(function(part){
      if(!part.trim()) return part;
      var pUp = part.toUpperCase();
      if(PRESERVE_KEYS[pUp]) return pUp;
      return part.charAt(0).toUpperCase() + part.slice(1);
    }).join('');
  }

  function isObj(o){ return o && typeof o === 'object' && !Array.isArray(o); }

function parseCertOrAcc(item){
  if (!item) return null;

  // Simple string
  if (typeof item === 'string') {
    var url = detectUrl(item);
    return url
      ? {label: cleanLabelFromUrl(url), url: url}
      : {label: item, url: ''};
  }

  // Object — look for known certification / accessory patterns
  if (typeof item === 'object') {
    var url = item.link || item.url || item.href || item.product_url || '';
    // prefer type + number if present
    var label = '';
    if (item.type && item.number){
      label = item.type + ' #' + item.number;
    } else if (item.type){
      label = item.type;
    } else if (item.label){
      label = item.label;
    } else if (item.title){
      label = item.title;
    } else if (item.name){
      label = item.name;
    } else if (url){
      label = cleanLabelFromUrl(url);
    }
    if (!label) return null;
    return {label: label, url: url};
  }

  return null;
}

})(); 



